export const SESSION_EXPIRED_KEY = "sessionExpired";
export const SESSION_EXPIRED_REASON_INACTIVE = "inactive";
export const FT_TOKEN_KEY = "ft-Token";
export const SESSION_IDLE_TIMEOUT_MS = 15 * 60 * 1000;
export const SESSION_IDLE_WARNING_MS = 30 * 1000;
